<template>
  <canvas ref="canvas" class="w-full h-full"></canvas>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { start } from './snow';
@Component
export default class Star extends Vue {
  mounted() {
    this.snowRender()
    window.addEventListener('resize', this.snowRender);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.snowRender)
    });
  }

  snowRender() {
    start(this.$refs.canvas as HTMLCanvasElement);
  }
}
</script>
